module.exports = __webpack_public_path__ + "137771fdf81f7788641d67e7ebe387e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/atom.png
// module id = 2461
// module chunks = 0